import { render, staticRenderFns } from "./productRecommend.vue?vue&type=template&id=365fb0fa&scoped=true"
import script from "./productRecommend.vue?vue&type=script&lang=js"
export * from "./productRecommend.vue?vue&type=script&lang=js"
import style0 from "./productRecommend.vue?vue&type=style&index=0&id=365fb0fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365fb0fa",
  null
  
)

export default component.exports